import { Icon, IconProps } from '@chakra-ui/react'

export function PaymentIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 30 22" {...props}>
      <path
        d="M24 13.3333V2.66667C24 1.2 22.8 0 21.3333 0H2.66667C1.2 0 0 1.2 0 2.66667V13.3333C0 14.8 1.2 16 2.66667 16H21.3333C22.8 16 24 14.8 24 13.3333ZM21.3333 13.3333H2.66667V2.66667H21.3333V13.3333ZM12 4C9.78667 4 8 5.78667 8 8C8 10.2133 9.78667 12 12 12C14.2133 12 16 10.2133 16 8C16 5.78667 14.2133 4 12 4ZM29.3333 4V18.6667C29.3333 20.1333 28.1333 21.3333 26.6667 21.3333H4C4 20 4 20.1333 4 18.6667H26.6667V4C28.1333 4 28 4 29.3333 4Z"
        fill="currentColor"
      />
    </Icon>
  )
}
